import { render, staticRenderFns } from "./DownloadFileModal.vue?vue&type=template&id=139329c0&"
import script from "./DownloadFileModal.vue?vue&type=script&lang=js&"
export * from "./DownloadFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports